export default __webpack_public_path__ + "static/media/42.e6f3da10.jpg";